/** 工單狀態（勿用 v1 OPEN／LOCK）。 */

export const WORK_ORDER_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  PROCESSING: 'PROCESSING',
  CLOSED: 'CLOSED',
  ABORTED: 'ABORTED',
};

export const WORK_ORDER_STATUS_LABELS = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  PROCESSING: '生產中',
  CLOSED: '已結案',
  ABORTED: '已中止',
};

export const WORK_ORDER_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'SUBMITTED', label: '已提交' },
  { value: 'PROCESSING', label: '生產中' },
  { value: 'CLOSED', label: '已結案' },
  { value: 'ABORTED', label: '已中止' },
];

/** 寫死色票：深底淺字 */
export const WORK_ORDER_STATUS_CLASS = {
  DRAFT: 'border-transparent bg-slate-600 text-slate-50',
  SUBMITTED: 'border-transparent bg-sky-600 text-sky-50',
  PROCESSING: 'border-transparent bg-amber-600 text-amber-50',
  CLOSED: 'border-transparent bg-emerald-600 text-emerald-50',
  ABORTED: 'border-transparent bg-rose-600 text-rose-50',
};

export function formatWorkOrderStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return WORK_ORDER_STATUS_LABELS[status] ?? status;
}

export function canEditWorkOrderDraft(detail) {
  return detail?.status === WORK_ORDER_STATUS.DRAFT;
}

/** PROCESSING 主檔僅可改排程日。 */
export function canEditWorkOrderSchedule(status) {
  return status === WORK_ORDER_STATUS.PROCESSING;
}

export function canEditWorkOrder(detail) {
  return canEditWorkOrderDraft(detail) || canEditWorkOrderSchedule(detail?.status);
}

export function canSubmitWorkOrder(status) {
  return status === WORK_ORDER_STATUS.DRAFT;
}

export function canDeleteWorkOrderDraft(status) {
  return status === WORK_ORDER_STATUS.DRAFT;
}

export function canApproveWorkOrder(status) {
  return status === WORK_ORDER_STATUS.SUBMITTED;
}

export function canRejectWorkOrder(status) {
  return status === WORK_ORDER_STATUS.SUBMITTED;
}

export function canCloseWorkOrder(status) {
  return status === WORK_ORDER_STATUS.PROCESSING;
}

export function canAbortWorkOrder(status) {
  return status === WORK_ORDER_STATUS.PROCESSING;
}

export function canReopenWorkOrder(status) {
  return status === WORK_ORDER_STATUS.CLOSED;
}

/** 任意狀態可改備註（契約 `update_remark`）。 */
export function canEditWorkOrderRemark(status) {
  return Boolean(status);
}

/** 入庫／出庫 create 僅 PROCESSING。 */
export function canOperateWorkOrderStockDocs(status) {
  return status === WORK_ORDER_STATUS.PROCESSING;
}
